"use client";
import styles from './FallbackComponent.module.scss';
import logo from '../../../../public/footerLogo.svg';
import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';


const FallbackComponent = () => {

    return (

        <div className={classNames(styles?.container || '', 'primary_font')}>

            <Image src={logo} alt='' />
            <h2>404</h2>
            <h3>Page Not Found</h3>
            <p>The page you are looking for does not exist <br />
                or may have been moved.</p>

            <Link
                href="/"
                className={classNames(styles?.btnBack ?? '', 'secondary-btn-color')}
            >
                Back to Home
            </Link>



        </div>

    );
};

export default FallbackComponent;